import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName } from '../../utils'
import { loadCity, loadCourses, loadJuries, loadTalents } from '../../utils/Network'
import { getUsersFilterSelectStyles, makeDarkSelectStyles } from '../selectStyles';

export default function SelectVerified({ callback, value, width ,name="is_verified", usersFilter, placeholder }) {

    const customStyles = usersFilter
        ? getUsersFilterSelectStyles({ width: width || '200px', border: 1 })
        : makeDarkSelectStyles({ width: width || '200px' });

    
    var options = [
        {
            label: "Verified",
            value: 1
        },
        {
            label : "Not Verified",
            value : 0
        },
        {
            label : "All",
            value : -1
        },
    ]

    const handleSelect = (e) => {
        var value = e.value;
        callback(value, name)

    }

    return (
        <>
            <div className="filter-select">
                <Select options={options}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder || "Verification"}
                    value={options && options.filter(obj => obj.value == value)}
                    menuPortalTarget={usersFilter ? document.body : undefined}
                    menuPosition={usersFilter ? 'fixed' : undefined}
                />
            </div>
            
        </>
    )
}
